import io from 'socket.io-client';

// Extract base URL from API URL
const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8000/ws';
const wsUrl = WS_URL.replace(/\/$/, '') + '/fund-transactions/';

let socket = null;
let reconnectAttempts = 0;
const maxReconnectAttempts = 5;
const callbacks = [];

const connect = () => {
    socket = new WebSocket(wsUrl);
    
    socket.onopen = () => {
        console.log('WebSocket connected');
        reconnectAttempts = 0;
    };
    
    socket.onmessage = (event) => {
        try {
            const data = JSON.parse(event.data);
            callbacks.forEach(callback => callback(data));
        } catch (error) {
            console.error('Error parsing WebSocket message:', error);
        }
    };
    
    socket.onclose = () => {
        console.log('WebSocket disconnected');
        attemptReconnect();
    };
    
    socket.onerror = (error) => {
        console.error('WebSocket error:', error);
    };
};

const attemptReconnect = () => {
    if (reconnectAttempts < maxReconnectAttempts) {
        reconnectAttempts++;
        console.log(`Attempting to reconnect... (${reconnectAttempts}/${maxReconnectAttempts})`);
        setTimeout(() => connect(), 3000);
    }
};

export const subscribeToUpdates = (callback) => {
    callbacks.push(callback);
    return () => {
        const index = callbacks.indexOf(callback);
        if (index > -1) {
            callbacks.splice(index, 1);
        }
    };
};

export const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({
            type: 'message',
            data: message
        }));
    }
};

// Auto-connect when service is imported
connect();
